module.exports = __webpack_public_path__ + "img/proList1_03.ef0d9655.jpg";